import type { User } from '@/types/entities'

export interface ChecklistItem {
  label: string
  completed: boolean
  description: string
}

// `signature` is the hash of the uploaded profile picture; the API sets it on every upload.
// (`user.picture` is a legacy sign-in field no upload sets, so it must not count here.)
export const profileChecklist = (user: User): ChecklistItem[] => [
  {
    label: 'Profile Picture',
    completed: !!user.signature,
    description: 'Add a professional profile photo',
  },
  {
    label: 'Biography',
    completed: !!user.bio && user.bio.trim().length >= 20,
    description: 'Tell your story to connect with buyers',
  },
  {
    label: 'PayPal Email',
    completed: !!user.paypal,
    description: 'Set up payment to receive your earnings',
  },
]
